import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
import { loginByUsername,logout } from "@/api/register";
import { setStore,getStore } from "@/utils/store";
import { setToken, setRefreshToken,removeToken,removeRefreshToken  } from "@/utils/auth";
import md5 from "js-md5";
import { validatenull } from "@/utils/validate";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    // 租户id
    tenantId:  getStore({name: 'tenantId'}) || "",
    // access_token: JSON.parse(localStorage.getItem("loginData").access_token)
    token: getStore({name: 'token'}) || "",
    refreshToken: getStore({name: 'refreshToken'}) || "",
    userInfo: getStore({name: 'userInfo'}) || [],
    loginShow: "",
  },
  // 同步提交
  mutations: {
    // 获取租户id
    tenantId(state, tenantId){
        state.tenantId = tenantId
    },
    SET_TENANT_ID: (state, tenantId) => {
      state.tenantId = tenantId;
      setStore({ name: "tenantId", content: state.tenantId });
    },
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token;
      setStore({ name: "token", content: state.token });
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
      if (userInfo.user_id && validatenull(userInfo.avatar)) {
        userInfo.avatar = require("@/assets/images/sculpture.png");
      }
      setStore({ name: "userInfo", content: state.userInfo });
    },
    SET_REFRESH_TOKEN: (state, refreshToken) => {
      setRefreshToken(refreshToken);
      state.refreshToken = refreshToken;
      setStore({ name: "refreshToken", content: state.refreshToken });
    },
    loginShowFn(state, loginShow) {
      state.loginShow = loginShow;
    },
    goIndexPage(state, data) {
      window.localStorage.clear();
      if (router.app._route.fullPath.indexOf("details") != -1) {
        router.replace("/studyIndex");
        setTimeout(() => {
          location.reload();
        }, 100);
      } else {
        location.reload();
      }
    },
  },
  getters:{
    userInfo:  state => state.userInfo,
  },
  // 异步提交
  actions: {
    //根据用户名登录
    LoginByUsername({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginByUsername(
          userInfo.tenantId,
          userInfo.username,
          md5(userInfo.password),
          userInfo.type,
          userInfo.key,
          userInfo.code,
          userInfo.dataType
        )
          .then((data) => {
            if (data.error_description) {
              Message({
                message: data.error_description,
                type: "error",
              });
            } else {
              commit("SET_TOKEN", data.access_token);
              commit("SET_REFRESH_TOKEN", data.refresh_token);
              commit("SET_TENANT_ID", data.tenant_id);
              commit("SET_USER_INFO", data);
            }
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 退出
    LogOut({commit}) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '');
          commit("SET_REFRESH_TOKEN", '');
          commit("SET_TENANT_ID", '');
          commit("SET_USER_INFO", '');
          removeToken();
          removeRefreshToken();
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
});
export default store;
